export const GET_OFFERINGTAB_FORMS = 'GET_OFFERINGTAB_FORMS';
export const GET_SEARCH_COURSES = 'GET_SEARCH_COURSES';
export const GET_BOOKLIST = "GET_BOOKLIST";
export const GET_WAITINGLIST = "GET_WAITINGLIST";
export const GET_COURSEFEE = "GET_COURSEFEE";
export const GET_ROOM_SCHEDULE_CONFLICTS = "GET_COURSE_SCHEDULE_CONFLICTS";
export const GET_ROOM_SCHEDULE_CONFLICTS_SUCCESS = "GET_COURSE_SCHEDULE_CONFLICTS_SUCCESS";
export const GET_ROOM_SCHEDULE_CONFLICTS_ERROR = "GET_COURSE_SCHEDULE_CONFLICTS_ERROR";
export const RESET_ROOM_SCHEDULE_CONFLICTS = "RESET_ROOM_SCHEDULE_CONFLICTS";
export const SHOW_CONFLICTS_MODAL = "SHOW_CONFLICTS_MODAL";
export const HIDE_CONFLICTS_MODAL = "HIDE_CONFLICTS_MODAL";
export const GET_FACULTY_SCHEDULE_CONFLICTS = "GET_FACULTY_SCHEDULE_CONFLICTS";
export const GET_FACULTY_SCHEDULE_CONFLICTS_SUCCESS = "GET_FACULTY_SCHEDULE_CONFLICTS_SUCCESS";
export const GET_FACULTY_SCHEDULE_CONFLICTS_ERROR = "GET_FACULTY_SCHEDULE_CONFLICTS_ERROR";
export const RESET_FACULTY_SCHEDULE_CONFLICTS = "RESET_FACULTY_SCHEDULE_CONFLICTS";